import { Navigate } from 'react-router-dom';
import { useAuth } from '@entities/auth';
import { AmlPolicyForm } from '@features/aml-policy';

export function AmlSettingsPage() {
  const { user } = useAuth();
  const isAdmin = user?.isAdmin === true || user?.role === 'ADMIN';
  if (!isAdmin) return <Navigate to="/balance" replace />;
  return <AmlPolicyForm />;
}
